import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { MessageRecipient } from 'src/app/core/models/message-recipient.model';
import { Message } from 'src/app/core/models/message.model';
import { RouterExtensionService } from 'src/app/core/services/router-extension.service';
import { MessagesState } from 'src/app/state/messages.reducer';
import { selectMessageRecipientById } from 'src/app/state/messages.selectors';

@Component({
  selector: 'app-message-history-video-viewer',
  templateUrl: './message-history-video-viewer.component.html',
  styleUrls: ['./message-history-video-viewer.component.scss'],
})
export class MessageHistoryVideoViewerComponent implements OnInit, OnDestroy {
  messageRecipientId: number;
  messageId: number;
  messageRecipient$: Observable<MessageRecipient>;
  messageRecipientSubscription: Subscription;
  message: Message;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private routerExtension: RouterExtensionService,
    private zone: NgZone,
    private store$: Store<MessagesState>
  ) {}

  ngOnInit(): void {
    this.route.params.forEach((params: Params) => {
      this.messageRecipientId = +params['messageRecipientId'];
      this.messageId = +params['messageId'];
    });

    this.messageRecipient$ = this.store$.select(
      selectMessageRecipientById(this.messageRecipientId)
    );

    this.messageRecipientSubscription = this.messageRecipient$.subscribe(
      (mr: MessageRecipient) => {
        this.message = mr.message_set.messages.find(
          (message: Message) => message.id === this.messageId
        );
      }
    );
  }

  ngOnDestroy() {
    this.messageRecipientSubscription.unsubscribe();
  }

  onCloseVideoViewer($event) {
    console.log('video player closed!');
    this.zone.run(() => {
      this.router.navigate([this.routerExtension.previousRoutePath.value]);
    });
  }
}
